import assert from "assert";
import moment from "moment-timezone";
import { Boolean, InstanceOf, Literal, Number, Partial, Record, String } from "runtypes";
import { DeadlineCoordinates } from "./coordinates";
import { PointSpecification } from "./points";
export const Deadline = Record({
  type: Literal("deadline"),
  course: Record({
    number: String,
    semester: String
  }),
  question: DeadlineCoordinates.And(
    Record({
      name: String
    })
  ),
  practice: Boolean,
  open: Boolean,
  disabled: Boolean
}).And(
  Partial({
    start: String.Or(InstanceOf(Date)),
    end: String.Or(InstanceOf(Date)),
    date: String.Or(InstanceOf(Date)),
    points: PointSpecification,
    lesson: Record({
      name: String,
      number: Number
    }),
    practiceCount: Number
  })
).withConstraint((deadline) => {
  if (!deadline.open) {
    assert(moment(deadline.start).isValid);
    assert(moment(deadline.end).isValid);
    assert(moment(deadline.date).isValid);
    assert(deadline.points);
    assert(deadline.lesson);
  }
  if (deadline.practice) {
    if (deadline.question.submissionType !== "STUMPER") {
      assert(deadline.practiceCount !== void 0);
    }
    assert(moment(deadline.start).valueOf === moment(deadline.end).valueOf);
    assert(moment(deadline.start).isSameOrBefore(moment(deadline.date)));
  } else if (!deadline.open) {
    assert(moment(deadline.start).isSameOrBefore(moment(deadline.date)));
    assert(moment(deadline.end).isAfter(moment(deadline.date)));
  }
  return true;
});
export function getDeadlineStart(deadline) {
  return !deadline.start ? void 0 : moment(deadline.start).toDate();
}
export function getDeadlineFullDeadline(deadline) {
  return !deadline.end ? void 0 : moment(deadline.end).toDate();
}
export function hasPartialCreditDeadline(deadline) {
  if (!deadline?.points) {
    return false;
  }
  const points = PointSpecification.check(deadline.points);
  return !!points.latePolicy;
}
export function getDeadlinePartialDeadline(deadline) {
  if (!deadline.end) {
    return;
  }
  if (!deadline.points) {
    return getDeadlineFullDeadline(deadline);
  }
  const points = PointSpecification.check(deadline.points);
  if (points.latePolicy?.policyType === "lateperday") {
    const lateDays = points.total / points.latePolicy.latePerDay;
    return moment(deadline.end).add(lateDays - 1, "day").toDate();
  } else if (points.latePolicy?.policyType === "lateinterval") {
    return moment(deadline.end).add(points.latePolicy.lateDays, "day").toDate();
  } else {
    return getDeadlineFullDeadline(deadline);
  }
}
export function getDeadlineSubmissionWarning(deadline, submitted) {
  const printedSubmittedTime = moment.tz(submitted, "America/Chicago").format("YYYY-MM-DD@hh:mm.ssA");
  if (moment(submitted).isBefore(moment(getDeadlineFullDeadline(deadline)))) {
    return `Submitted ${printedSubmittedTime} for full credit before the deadline ${moment(getDeadlineFullDeadline(deadline)).subtract(1, "minute").format("YYYY-MM-DD")}@11:59.59PM`;
  } else if (moment(submitted).isBefore(moment(getDeadlinePartialDeadline(deadline)))) {
    return `Submitted ${printedSubmittedTime} for late credit before the deadline ${moment(getDeadlinePartialDeadline(deadline)).subtract(1, "minute").format("YYYY-MM-DD")}@11:59.59PM`;
  } else {
    return `Submitted ${printedSubmittedTime} for no credit after the deadline ${moment(getDeadlinePartialDeadline(deadline)).subtract(1, "minute").format("YYYY-MM-DD")}@11:59.59PM`;
  }
}
export function afterFinalDeadline(deadline, submitted) {
  return moment(submitted).isAfter(moment(getDeadlinePartialDeadline(deadline)));
}
//# sourceMappingURL=deadline.js.map
